module.exports = __webpack_public_path__ + "static/Augmented-Reality-Platform-267fc0f71c2c92fa679755ff9cb3d214.jpg";